import React from 'react'
import { withRouter } from 'react-router-dom'
/* REDUX */
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'

const form = reduxForm({
	form: 'search',
})

class Searchbar extends React.Component {

	handleSubmit = (formData) => {
		let query = formData.query
		if (!query) {
			return
		}
		this.props.history.push("/search?q=" + query + "&t=relevance")
	}

	render() {
		const { handleSubmit } = this.props
		return (
			<div className="searchbar">
				<h2 className="heading">Search trip reports</h2>
				<form className="searchform" onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
					<Field type="text" name="query" className="form-control" component="input" placeholder="e.g. SFO to KIX, Delta Air" />
					<button type="submit" className="btn btn-query">Search</button>
				</form>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	const formState = state.form.search || {}
	const formValues = formState.values
	return {
		formValues
	}
}

export default withRouter(connect(mapStateToProps)(form(Searchbar)))



// WEBPACK FOOTER //
// ./src/components/Global/Searchbar.js